import type { Language } from './schemas/simulation'

/** Fixed display guidance; a generated value or legacy record cannot establish real testing. */
export const PRODUCT_DRAFT_COPY = {
  en: 'This is a product draft. Taste, texture and manufacturing suitability need confirmation through real tasting and manufacturing trials.',
  ko: '제품 초안입니다. 맛·식감과 제조 적합성은 실제 시식·제조 시험을 거쳐 확인해야 합니다.',
  ja: '製品の草案です。味・食感と製造への適合性は、実際の試食・製造試験を通じて確認する必要があります。',
  zh: '这是产品草案。口味、口感及生产适用性须通过实际试吃和生产试验确认。',
} as const satisfies Record<Language, string>

/** Current records have no verified shelf-life evidence. A numeric value cannot change this notice. */
export const SHELF_LIFE_COPY = {
  en: {
    label: 'Shelf life unverified · validate per product',
    note: 'The suggested duration is not a validated shelf life. The product, process, packaging and storage conditions need assessment.',
  },
  ko: {
    label: '소비기한 미검증 · 제품별 확인 필요',
    note: '제안된 기간은 검증된 소비기한이 아닙니다. 제품·공정·포장·보관 조건에 맞는 확인이 필요합니다.',
  },
  ja: {
    label: '保存期間は未検証・製品ごとの確認が必要',
    note: '提示された期間は検証済みの保存期間ではありません。製品・工程・包装・保存条件に基づく確認が必要です。',
  },
  zh: {
    label: '保质期未验证 · 须按产品确认',
    note: '建议的期限不是经过验证的保质期。须结合产品、工艺、包装及储存条件进行确认。',
  },
} as const satisfies Record<Language, { label: string; note: string }>

/** 결과 화면 안내 태그. 긴 문장 대신 태그 두 개로 보이고, 누르면 PRODUCT_DRAFT_COPY·SHELF_LIFE_COPY.note 전문을 띄운다 */
export const RESULT_NOTICE_TAGS = {
  en: {
    draft: 'Draft · tasting needed',
    shelf: 'Shelf life unverified',
    title: 'Before you produce',
  },
  ko: { draft: '초안 · 시식 확인 필요', shelf: '소비기한 미검증', title: '생산 전에 확인하세요' },
  ja: { draft: '草案・試食が必要', shelf: '保存期間は未検証', title: '生産前の確認' },
  zh: { draft: '草案 · 需试吃', shelf: '保质期未验证', title: '生产前请确认' },
} as const satisfies Record<Language, { draft: string; shelf: string; title: string }>
